import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIImage from 'UIComponents/image/UIImage';
import { Integrations } from 'pricing-pages-ui/constants/Integrations';
import { Section, SectionHeader, SectionSubTitle, SectionTitle } from './SharedComponents';

const IntegrationsSection = () => {
  return /*#__PURE__*/_jsxs(Section, {
    use: "shaded",
    padding: "60px 0 60px",
    margin: "90px 0 0",
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.integrations.title"
        })
      }), /*#__PURE__*/_jsx(SectionSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "pricingPage.integrations.subtitle_jsx",
          elements: {
            FormattedNumber
          }
        })
      })]
    }), /*#__PURE__*/_jsx(UIFlex, {
      wrap: "wrap",
      align: "stretch",
      justify: "center",
      children: Integrations.map(({
        appName,
        logo
      }) => /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "center",
        direction: "column",
        className: "text-center",
        style: {
          maxWidth: '104px',
          height: '100%'
        },
        children: [/*#__PURE__*/_jsx(UIImage, {
          src: logo,
          height: "48px",
          width: "48px",
          className: "m-all-4"
        }), appName]
      }, appName))
    })]
  });
};

export default IntegrationsSection;